import type { RouteRecordRaw } from 'vue-router';
import type { App } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import { exceptionRoute, notFoundRoute, rootRoute, liveRoute } from './routes';
import { getAppEnvConfig } from '../libs/env';
import registerGuard from './guard';

const { VITE_PUBLIC } = getAppEnvConfig();

export const basicRoutes = [exceptionRoute, rootRoute, notFoundRoute];

export const appRoutes = [liveRoute];

export const routes = [...basicRoutes, ...appRoutes] as RouteRecordRaw[];

/**
 * 声明路由
 */
export const router = createRouter({
  history: createWebHistory(VITE_PUBLIC),
  routes,
  strict: true,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

/**
 * 路由中间件守卫
 */
registerGuard(router);

/**
 * 配置路由
 */
export function setupRouter(app: App<Element>) {
  app.use(router);
}
